export const environment = {
  production: true,
  baseHref: '/',
  bxURL: 'https://bx.ielts.dev.idp.com',
  bxSearchURL: 'https://bxsearch.ielts.dev.idp.com',
  cxURL: 'https://ielts.dev.idp.com',
  studentEssentialsURL: 'https://www.idp.com/student-essentials',
  bxsearchSpeakingUrl: 'https://bxsearch.ielts.dev.idp.com/book-ielts/speaking',
  mainDomain: '.ielts.dev.idp.com',
  domainUrl: 'https://account.ielts.dev.idp.com',
  cognitoProxy: 'https://ielts.api.security.dev.idp.com/v1/ielts/cognito-proxy',
  splunkLoggerUrl: 'https://http-inputs-idpeducation.splunkcloud.com:443/services/collector/event',
  userProfileUrl: 'https://api.account.ielts.dev.idp.com/v1/userprofile',
  forgotPassResetmailApi: 'https://api.account.ielts.dev.idp.com/v1/mail-service/acknowledgement/forgot-password',
  resetPassMailApi: 'https://api.account.ielts.dev.idp.com/v1/mail-service/acknowledgement/reset-password',
  nextBestActionApi: 'https://api.account.ielts.dev.idp.com/v1/externalapi/nextBestAction',
  studentEssentialApi: 'https://api.account.ielts.dev.idp.com/v1/studentEssentialServices',
  rtbfStatusApi: 'https://api.account.ielts.dev.idp.com/v1/user/{userprofileID}/rtbf/status',
  rtbfApi: 'https://api.account.ielts.dev.idp.com/v1/user/{userProfileId}/rtbf',
  rtbfRevokeApi: 'https://api.account.ielts.dev.idp.com/v1/user/{userProfileId}/rtbf/revoke',
  userPoolId: 'ap-southeast-1_vUoYaWWei',
  userPoolWebClientId: '1vt8n1pm2oki1obkovtclml2h',
  identityPoolId: 'ap-southeast-1:ea67cba4-15dc-4f6f-bd10-ddaf9aa89402',
  agentUserPoolId: 'ap-southeast-1_fA7PYKh7h',
  agentUserPoolWebClientId: '7a24ng9rtsigq4nsbqmh32u5r0',
  bucketName: 'idp-customer-identity-v1-dev',
  secure: true,
  sameSite: 'strict',
  ttBaseURL: 'https://api.test-taker.dev.ielts.com',
  agentSearchUserProfileUrl: 'https://api.account.ielts.dev.idp.com/v1/agents/userProfiles/search',
  agentCreateUserProfileUrl: 'https://api.account.ielts.dev.idp.com/v1/agents/userProfiles',
  onetrustCookieId: '0024db59-ae7f-45d1-9b4a-5b3349b4bf74-test',
  environmentName: 'development',
  requestExpireTime: { dashboard: 1000, userProfile: 1000, refreshToken: 900000 },
  s3IdImageUrl: '/ap-southeast-1:341cf1b7-5f6d-4e07-a0dc-648f0ad5bd5f/id-upload-image_1.png',
  secondaryS3IdImageUrl: '/ap-southeast-1:341cf1b7-5f6d-4e07-a0dc-648f0ad5bd5f/id-upload-image_2.png',
  checkYourResult: 'https://ielts.dev.idp.com/results/check-your-result',
  splunkLoggerAuthValue: 'd2e2afc4-9bb4-47ee-bed2-05e8e7f27aa8',
  buildInfo: '**BUILD** **VERSION** DEV',
  piiEncryptionKey: ''
}
